






import Vue from 'vue';
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import boost from 'highcharts/modules/boost';
import { Chart } from 'highcharts-vue';

exporting(Highcharts);
boost(Highcharts);

export default Vue.extend({
  name: 'DocumentRepoReadabilityChart',
  components: {
    Chart,
  },
  props: {
    title: String,
    xLabel: String,
    selectedIndex: Number,
    options: {} as () => Highcharts.Options,
  },
  data() {
    return {
      isMounted: false,
    };
  },
  computed: {
    chartOptions(): Highcharts.Options {
      const newOptions = Highcharts.merge(this.options, {
        title: {
          text: this.title,
        },
        chart: {
          zoomType: 'x',
          panKey: 'meta',
          panning: true,
        },
        tooltip: {
          split: true,
        },
        xAxis: {
          title: {
            text: this.xLabel,
          },
          plotLines: [{
            color: '#999999',
            width: 1,
            dashStyle: 'Dash',
            value: this.selectedIndex,
          }],
        },
        yAxis: {
          title: {
            text: 'Readability',
          },
        },
        plotOptions: {
          series: {
            allowPointSelect: true,
            point: {
              events: {
                select: this.getPointSelectedCallback(),
              },
            },
          },
        },
      } as Highcharts.Options);
      if (this.isMounted && (newOptions.series?.length ?? 0) > 0) {
        this.hideLoading();
      }
      return newOptions;
    },
  },
  mounted(): void {
    this.isMounted = true;
  },
  methods: {
    hideLoading(): void {
      (this.$refs.chart as Vue & { chart: { hideLoading(): void }}).chart.hideLoading();
    },
    pointSelected(index: number) {
      this.$emit('point-selected', index);
    },
    getPointSelectedCallback(): Highcharts.PointSelectCallbackFunction {
      const emitter = this.pointSelected.bind(this);
      return ((function callback(): void {
        const point = this as (Highcharts.Point);
        emitter(point.x);
      }) as Highcharts.PointSelectCallbackFunction);
    },
  },
});
